import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import type { Ref } from 'react';
import { PlayButton } from './PlayButton';
import { ComponentVideoBlock } from '$/(cms)/_modules/cmsService/types';
import ExpandableText from '$/components/cms/components-internal/ExpandableText';

type Props = {
  aspectPadding: number;
  caption?: string | null;
  iframeSrc: string;
  iframeRef: Ref<HTMLIFrameElement>;
  isPlaying: boolean;
  isPortrait: boolean;
  onPlay: () => void;
  placeholderImage: ComponentVideoBlock['placeholderImage'];
  sectionTitle?: string | null;
};

export const YouTubeEmbed = ({
  aspectPadding,
  caption,
  iframeSrc,
  iframeRef,
  isPlaying,
  isPortrait,
  onPlay,
  placeholderImage,
  sectionTitle,
}: Props) => (
  <div
    className={`overflow-hidden rounded-radius/card border border-borders/default bg-fill/alternative-1 ${
      isPortrait ? 'max-w-general/4-col-width' : ''
    }`}
  >
    <div
      className="relative w-full bg-fill/alternative-1"
      style={{ paddingTop: `${aspectPadding}%` }}
    >
      {isPlaying ? (
        <iframe
          ref={iframeRef}
          src={iframeSrc}
          title={sectionTitle || 'YouTube video'}
          className="absolute inset-0 size-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      ) : (
        <>
          <button
            type="button"
            className="absolute inset-0 z-1 size-full"
            onClick={onPlay}
            aria-label="Play video"
          />
          <CmsImage
            unoptimized
            alt={placeholderImage?.alternativeText ?? 'Video placeholder'}
            src={placeholderImage?.url ?? ''}
            fill
            className="object-cover"
            sizes={{ _: '100vw', md: 900 }}
            priority={false}
          />
          <PlayButton onClick={onPlay} />
        </>
      )}
    </div>

    {caption && (
      <ExpandableText
        text={caption}
        maxChars={168}
        maxCharsMobile={90}
        className="mhg-alpha-typography-body-2-relaxed p-spacing/padding/soft-12px text-text/secondary"
      />
    )}
  </div>
);
